import type {
    SubscriptionSettingsResponse,
    UnsubscribeRequest,
    UnsubscribeResponse
} from '~/types';
import type { NitroFetchOptions } from 'nitropack';
import { useApiUtils } from 'x1-base/composables';
import { useCustomFetch } from '~/composables';

export function useSubscriptions() {
    const apiUnSubBasePath = `/v1/unsubscribe`;
    const useApiUtilsObj = useApiUtils();
    const $_fetch = useCustomFetch();

    async function getSubscriptions(uid: string): Promise<SubscriptionSettingsResponse | Error> {
        const url = `${apiUnSubBasePath}/`;
        const config: NitroFetchOptions<string> = {
            method: 'GET',
            query: { uid }
        };

        try {
            const response = await $_fetch<SubscriptionSettingsResponse>(url, config);
            return response;
        } catch (err) {
            return useApiUtilsObj.getErrorObj(err);
        }
    }
    
    async function setSubscriptions(uid: string, unsubscribeList: string[]): Promise<UnsubscribeResponse | Error> {
        const url = `${apiUnSubBasePath}/`;

        const config: NitroFetchOptions<string> = {
            method: 'POST',
            body: {
                uid,
                email_types: unsubscribeList
            }
        };

        try {
            const response = await $_fetch<UnsubscribeResponse>(url, config);
            return response;
        } catch (err) {
            return useApiUtilsObj.getErrorObj(err);
        }
    }

    return {
        getSubscriptions,
        setSubscriptions
    };
}
